import { render, staticRenderFns } from "./SelectOrigin.vue?vue&type=template&id=193a82cf&"
import script from "./SelectOrigin.vue?vue&type=script&lang=js&"
export * from "./SelectOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports